<template>
  <div class="campus-info-container">
    <pc-navbar />
    <block-overview
      :overview-data="schoolRecruitOverview"
      @clickBuyMember="clickBuyMember"
    />
    <div class="campus-info-content">
      <block-campus-tab
        :tab-list="tabList"
        :active-index="activeIndex"
        @clickTab="clickTab"
      />
      <div v-show="activeIndex === 0" class="campus-table-content">
        <div
          class="table-filter-content"
          v-clickoutside="() => (recruitmentBatchState = false)"
        >
          <div
            class="recruitment-batch-select"
            @click.stop="recruitmentBatchState = !recruitmentBatchState"
          >
            <div
              class="recruitment-batch-text flex align-items-center"
              :class="{ 'active-batch-text': !!searchPayload.batch.length }"
            >
              <i class="iconfont iconFrame"></i>
              <span>{{ selectBatchText }}</span>
              <i
                class="iconfont icona-Frame1"
                :class="{ 'rotate-180': recruitmentBatchState }"
              ></i>
            </div>
            <div
              v-show="recruitmentBatchState"
              class="select-options-container"
            >
              <div
                v-for="(item, index) in recruitmentBatches"
                :key="index"
                class="option-item"
                @click.stop="clickRecruitmentItem(item)"
              >
                <img
                  class="checked-icon"
                  :src="
                    searchPayload.batch.includes(item.value)
                      ? 'https://logo.wondercv.com/banners/408aKbzM1LidZpA.png'
                      : 'https://logo.wondercv.com/banners/QU98AzOL4ng0kUP.png'
                  "
                  alt=""
                />
                {{ item.label }}
              </div>
            </div>
          </div>
          <div class="search-filter-middle">
            <div class="search-input-content">
              <img
                class="search-input-icon"
                src="https://logo.wondercv.com/banners/jHRs5mW7bbzI5uJ.png"
                alt=""
              />
              <input
                v-model.trim="searchPayload.keyword"
                class="search-input"
                type="text"
                name=""
                id=""
                placeholder="搜索职位、城市、公司、行业"
                @keydown.enter="filterChange"
              />
            </div>
            <div class="flex align-items-center">
              <div
                class="reset-filter-content flex align-items-center"
                @click="resetFilter"
              >
                <img
                  class="reset-icon"
                  src="https://logo.wondercv.com/banners/VByAm5oV9T10oAb.png"
                  alt=""
                />
                <span>重置所有信息</span>
              </div>
              <div class="flex align-items-center recommend-switch">
                <span>有内推</span>
                <el-switch
                  v-model="searchPayload.recommend"
                  active-color="#FF6644"
                  @change="recommendChange"
                ></el-switch>
              </div>
            </div>
          </div>
          <div class="more-filter-content flex align-items-center">
            <el-select
              v-model="searchPayload.graduation"
              placeholder="毕业年份"
              style="margin-right: 8px"
              clearable
              @change="filterChange"
            >
              <el-option
                v-for="item in graduationYears"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="searchPayload.degree"
              placeholder="学历要求"
              style="margin-right: 8px"
              clearable
              @change="filterChange"
            >
              <el-option
                v-for="item in educationRequirements"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="searchPayload.company_nature"
              placeholder="企业性质"
              style="margin-right: 8px"
              clearable
              @change="filterChange"
            >
              <el-option
                v-for="item in companyNatures"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-date-picker
              v-model="searchPayload.start_at"
              type="date"
              placeholder="网申开始时间"
              style="margin-right: 8px"
              clearable
              @change="filterChange"
            ></el-date-picker>
            <el-date-picker
              v-model="searchPayload.end_at"
              type="date"
              placeholder="网申结束时间"
              style="margin-right: 8px"
              clearable
              @change="filterChange"
            ></el-date-picker>
            <el-select
              v-model="searchPayload.step"
              placeholder="求职进度"
              clearable
              @change="stepPickerChange"
            >
              <el-option
                v-for="item in applicationStatuses"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <block-campus-table
          :table-data="recruitTableData"
          :is-login="isLogin"
          @clickRemark="clickRemark"
          @clickAddCalendar="clickAddCalendar"
          @displayLoginModal="loginModalVisible = true"
          @buyMember="clickBuyMember"
        />
        <div class="pagination-content">
          <el-pagination
            hide-on-single-page
            :current-page.sync="searchPayload.page"
            :page-size="searchPayload.page_size"
            :total="totalCount"
            layout="prev, pager, next"
            @current-change="sizeChange"
          />
        </div>
      </div>
      <div v-show="activeIndex === 1" class="campus-calendar-wrapper">
        <block-campus-calendar
          :active-index="activeIndex"
          :is-login="isLogin"
        />
      </div>
    </div>
    <pay-alert v-if="payAlertVisible" @close="payAlertVisible = false" />
    <member-breaking-modal
      v-if="memberBreakingVisible"
      @clickBtnItem="clickBtnItem"
      @close="memberBreakingVisible = false"
    />
    <campus-member-modal
      v-if="campusMemberVisible"
      @close="closeCampusMemberModal"
    />
    <add-calendar-modal
      v-if="addCalendarVisible"
      :operation-table-item="operationTableItem"
      @close="closeAddCalendarModal"
    />
    <block-remark
      v-if="remarkVisible"
      :operation-table-item="operationTableItem"
      @close="clickRemarkClose"
    />
    <login-modal v-if="loginModalVisible" @close="closeLoginModal" />
  </div>
</template>
<script>
import api from "@/api";
import PcNavbar from "@/components/base/navbar";
import BlockOverview from "./BlockOverview.vue";
import BlockCampusTab from "./BlockCampusTab.vue";
import BlockCampusTable from "./BlockCampusTable.vue";
import CampusMemberModal from "./CampusMemberModal.vue";
import MemberBreakingModal from "./MemberBreakingModal.vue";
import BlockRemark from "./BlockRemark.vue";
import AddCalendarModal from "./AddCalendarModal.vue";
import PayAlert from "@/views/account/user/payAlert.vue";
import BlockCampusCalendar from "./BlockCampusCalendar.vue";
import LoginModal from "@/components/base/LoginModal.vue";
import clickoutside from "@/assets/js/clickoutside";
import { mapState } from "vuex";
import {
  GRADUATION_YEARS,
  EDUCATION_REQUIREMENTS,
  COMPANY_NATURES,
  RECRUITMENT_BATCHES,
  TAB_LIST,
  APPLICATION_STATUSES,
} from "./const.js";
import { getUserInfo } from "@/assets/js/util";

export default {
  components: {
    PcNavbar,
    BlockOverview,
    BlockCampusTab,
    BlockCampusTable,
    CampusMemberModal,
    MemberBreakingModal,
    PayAlert,
    BlockRemark,
    AddCalendarModal,
    BlockCampusCalendar,
    LoginModal,
  },
  directives: {
    clickoutside,
  },
  data() {
    return {
      tabList: TAB_LIST,
      graduationYears: GRADUATION_YEARS,
      educationRequirements: EDUCATION_REQUIREMENTS,
      companyNatures: COMPANY_NATURES,
      recruitmentBatches: RECRUITMENT_BATCHES,
      applicationStatuses: APPLICATION_STATUSES,
      activeIndex: 0,
      recruitmentBatchState: false,
      memberBreakingVisible: false,
      remarkVisible: false,
      addCalendarVisible: false,
      searchPayload: {
        page: 1,
        page_size: 10,
        keyword: undefined,
        graduation: undefined,
        degree: undefined,
        company_nature: undefined,
        start_at: undefined,
        end_at: undefined,
        step: undefined,
        recommend: undefined,
        batch: [],
      },
      recruitTableData: [],
      totalCount: 0,
      schoolRecruitOverview: {},
      campusMemberVisible: false,
      payAlertVisible: false,
      loginModalVisible: false,
      operationTableItem: {},
    };
  },
  computed: {
    ...mapState("me", ["isLogin"]),
    selectBatchText() {
      const { batch } = this.searchPayload;
      if (batch.length === 1) {
        return batch[0];
      } else if (batch.length === this.recruitmentBatches.length) {
        return `招聘批次（不限）`;
      } else if (batch.length > 1) {
        return `招聘批次（${batch.length}）`;
      }
      return "招聘批次";
    },
  },
  watch: {},
  methods: {
    closeLoginModal(type) {
      this.loginModalVisible = false;
      if (type === "refresh") {
        getUserInfo();
        this.getRecruitTableData();
      }
    },
    clickBuyMember() {
      if (!this.isLogin) {
        this.loginModalVisible = true;
        return;
      }
      this.memberBreakingVisible = true;
    },
    clickTab(index) {
      this.activeIndex = index;
    },
    clickRecruitmentItem(item) {
      if (!this.isLogin) return (this.loginModalVisible = true);
      if (this.searchPayload.batch.includes(item.value)) {
        this.searchPayload.batch = this.searchPayload.batch.filter(
          (value) => value !== item.value
        );
      } else {
        this.searchPayload.batch.push(item.value);
      }
      this.getRecruitTableData();
    },
    sizeChange(page) {
      if (!this.isLogin) {
        this.loginModalVisible = true;
        this.searchPayload.page = 1;
        return;
      }
      this.searchPayload.page = page;
      this.getRecruitTableData();
    },
    clickBtnItem(type) {
      switch (type) {
        case "campus":
          this.campusMemberVisible = true;
          break;
        case "cv":
          this.payAlertVisible = true;
          break;
      }
      this.memberBreakingVisible = false;
    },
    closeCampusMemberModal(type) {
      this.campusMemberVisible = false;
      if (type === "refresh") {
        getUserInfo();
        this.$store.dispatch('me/getUserInfo');
      }
    },
    initFilter() {
      this.searchPayload = {
        page: 1,
        page_size: 10,
        keyword: undefined,
        graduation: undefined,
        degree: undefined,
        company_nature: undefined,
        start_at: undefined,
        end_at: undefined,
        step: undefined,
        recommend: undefined,
        batch: [],
      };
    },
    stepPickerChange(value) {
      if (!this.isLogin) {
        this.loginModalVisible = true;
        this.searchPayload.step = undefined;
        return;
      }
      if (!value) this.searchPayload.step = undefined;
      this.searchPayload.page = 1;
      this.getRecruitTableData();
    },
    filterChange() {
      if (!this.isLogin) {
        this.initFilter();
        this.loginModalVisible = true;
        return;
      }
      this.searchPayload.page = 1;
      this.getRecruitTableData();
    },
    recommendChange(value) {
      if (!this.isLogin) {
        this.initFilter();
        this.loginModalVisible = true;
        return;
      }
      if (!value) this.searchPayload.recommend = undefined;
      this.getRecruitTableData();
    },
    resetFilter() {
      this.initFilter();
      if (!this.isLogin) return (this.loginModalVisible = true);
      this.getRecruitTableData();
    },
    clickRemark(row) {
      this.operationTableItem = row;
      this.remarkVisible = true;
    },
    clickRemarkClose(type) {
      this.remarkVisible = false;
      if (type === "refresh") {
        this.getRecruitTableData();
      }
    },
    closeAddCalendarModal(type) {
      this.addCalendarVisible = false;
      if (type === "refresh") {
        this.getRecruitTableData();
      }
    },
    clickAddCalendar(row) {
      this.operationTableItem = row;
      this.addCalendarVisible = true;
    },
    async getRecruitTableData() {
      try {
        const res = await api.campus.fetchSchoolRecruitsList({
          ...this.searchPayload,
          batch:
            this.searchPayload.batch.length > 0
              ? this.searchPayload.batch.join(",")
              : undefined,
        });
        if (res.code === 1000) {
          const {
            recruitments = [],
            top_recruitments = [],
            total_count,
          } = res.data;
          this.recruitTableData =
            this.searchPayload.page === 1
              ? [...top_recruitments, ...recruitments]
              : [...recruitments];
          this.totalCount = total_count;
        } else if (res.code === 200106) {
          this.initFilter();
          this.clickBuyMember();
        }
      } catch (error) {
        console.log(res);
      }
    },
    async getSchoolRecruitOverview() {
      try {
        const res = await api.campus.fetchSchoolRecruitOverview();
        if (res.code === 1000) {
          this.schoolRecruitOverview = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.$store.dispatch('app/setNavbarAction', '校招信息');
    this.getRecruitTableData();
    this.getSchoolRecruitOverview();
  },
};
</script>
<style lang="scss" scoped>
.campus-info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: #f5f5f7;
  padding-top: 76px;
  padding-bottom: 20px;
  .campus-info-content {
    width: 1200px;
    background-color: #fff;
    margin-top: 16px;
    border-radius: 12px;
    .campus-table-content {
      width: 100%;
      padding: 20px;
      box-sizing: border-box;
      .table-filter-content {
        margin-bottom: 12px;
        .recruitment-batch-select {
          position: relative;
          .recruitment-batch-text {
            display: flex;
            align-items: center;
            padding: 0 12px;
            box-sizing: border-box;
            height: 32px;
            border-radius: 6px;
            background: #f7f8fa;
            width: fit-content;
            color: #1d2129;
            cursor: pointer;
            .icona-Frame1 {
              margin-left: 6px;
              font-size: 10px;
              &.rotate-180 {
                transform: rotate(180deg);
              }
            }
            .iconFrame {
              margin-right: 6px;
              font-size: 18px;
            }
            &.active-batch-text {
              color: #ff6644;
              background-color: #fff2ef;
            }
          }
          .select-options-container {
            position: absolute;
            top: calc(100% + 4px);
            padding: 4px 0;
            border-radius: 4px;
            background-color: #fff;
            border: 1px solid #e5e6eb;
            z-index: 8;
            min-width: 180px;
            border-radius: 4px;
            box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
            .option-item {
              display: flex;
              align-items: center;
              height: 32px;
              padding: 0 12px;
              box-sizing: border-box;
              cursor: pointer;
              width: 100%;
              color: #1d2129;
              font-size: 14px;
              .checked-icon {
                width: 14px;
                height: 14px;
                margin-right: 8px;
              }
              &:hover {
                background-color: #f7f8fa;
              }
            }
          }
        }
        .search-filter-middle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .search-input-content {
            display: flex;
            align-items: center;
            height: 32px;
            border-radius: 6px;
            width: 532px;
            margin-top: 20px;
            border: 1px solid #e5e6eb;
            padding-left: 12px;
            .search-input-icon {
              width: 14px;
              height: 14px;
            }
            .search-input {
              flex: 1;
              outline: none;
              border: none;
              background: transparent;
              padding-left: 12px;
            }
          }
          .reset-filter-content {
            cursor: pointer;
            color: #4b596b;
            font-size: 14px;
            font-weight: 400;
            .reset-icon {
              width: 14px;
              height: 14px;
              margin-right: 8px;
            }
            &::after {
              content: "";
              display: inline-block;
              width: 1px;
              background: #e5e6ec;
              height: 14px;
              margin: 0 20px;
            }
          }
          .recommend-switch {
            color: #4b596b;
            span {
              margin-right: 8px;
            }
          }
        }
        .more-filter-content {
          margin-top: 12px;
        }
      }
    }
    .campus-calendar-wrapper {
      padding: 20px;
    }
  }
}
</style>
<style lang="scss">
.pagination-content {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
  .el-pagination {
    button {
      &:hover {
        color: #ff6644;
      }
    }
    .el-pager {
      li:hover,
      .active {
        color: #ff6644;
      }
    }
  }
}
</style>
